import { render, staticRenderFns } from "./Drugstores.vue?vue&type=template&id=89b494d8&scoped=true&"
import script from "./Drugstores.vue?vue&type=script&lang=ts&"
export * from "./Drugstores.vue?vue&type=script&lang=ts&"
import style0 from "./Drugstores.vue?vue&type=style&index=0&id=89b494d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b494d8",
  null
  
)

export default component.exports